import { useState } from "react";

import {
    FaCreditCard,
    FaGooglePay,
    FaWallet,
    FaMoneyBillWave,
    FaPlus,
} from "react-icons/fa";

import "./CustomerPaymentMethods.css";

function CustomerPaymentMethods() {

    const [selected, setSelected] = useState("Cash On Delivery");

    const methods = [

        {
            id: "cod",
            title: "Cash On Delivery",
            subtitle: "Pay when your order arrives.",
            icon: <FaMoneyBillWave />,
        },

        {
            id: "upi",
            title: "UPI",
            subtitle: "Google Pay • PhonePe • Paytm",
            icon: <FaGooglePay />,
        },

        {
            id: "card",
            title: "Credit / Debit Card",
            subtitle: "Visa • MasterCard • RuPay",
            icon: <FaCreditCard />,
        },

        {
            id: "wallet",
            title: "HomeFoods Wallet",
            subtitle: "Coming Soon",
            icon: <FaWallet />,
        },

    ];

    return (

        <div className="payment-page">

            <div className="payment-header">

                <FaCreditCard />

                <div>

                    <h2>

                        Payment Methods

                    </h2>

                    <p>

                        Choose your preferred payment method.

                    </p>

                </div>

            </div>

            <div className="payment-card">

                {

                    methods.map((item) => (

                        <label
                            key={item.id}
                            className={`payment-item ${
                                selected === item.title
                                    ? "active"
                                    : ""
                            }`}
                        >

                            <div className="payment-left">

                                <div className="payment-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <input
                                type="radio"
                                checked={
                                    selected === item.title
                                }
                                onChange={() =>
                                    setSelected(item.title)
                                }
                            />

                        </label>

                    ))

                }

            </div>

            <button className="add-payment-btn">

                <FaPlus />

                Add New Card

            </button>

        </div>

    );

}

export default CustomerPaymentMethods;